import './Steps.css';

function Steps() {
  return (
    <section id="pasos" className="steps-section py-5">
      <div className="container text-center">
        <h2 className="fw-bold mb-4 animate-on-scroll">¿Cómo agendar una reunión?</h2>
        <p className="text-muted fs-5 w-75 mx-auto mb-5 animate-on-scroll">
          Sigue estos sencillos pasos y déjanos ayudarte a hacer realidad tu proyecto.
        </p>

        <div className="timeline">
          
          <div className="timeline-item animate-on-scroll">
            <div className="timeline-icon bg-primary text-white">
              <i className="bi bi-telephone"></i>
            </div>
            <h5 className="fw-bold mt-3">Contáctanos</h5>
            <p className="text-muted">Envíanos un mensaje por WhatsApp, llamada o correo y agenda tu cita.</p>
          </div>

          <div className="timeline-item animate-on-scroll">
            <div className="timeline-icon bg-primary text-white">
              <i className="bi bi-people"></i>
            </div>
            <h5 className="fw-bold mt-3">Primera reunión</h5>
            <p className="text-muted">Nos reunimos contigo (presencial o videollamada) para escucharte y conocer a fondo tus ideas y necesidades.</p>
          </div>

          <div className="timeline-item animate-on-scroll">
            <div className="timeline-icon bg-primary text-white">
              <i className="bi bi-pencil-square"></i>
            </div>
            <h5 className="fw-bold mt-3">Propuestas y bocetos</h5>
            <p className="text-muted">En la segunda reunión te presentamos las propuestas visuales y prototipos de tu proyecto.</p>
          </div>

          <div className="timeline-item animate-on-scroll">
            <div className="timeline-icon bg-primary text-white">
              <i className="bi bi-check-circle"></i>
            </div>
            <h5 className="fw-bold mt-3">Luz verde al proyecto</h5>
            <p className="text-muted">Aprobamos los detalles finales y comenzamos oficialmente el desarrollo.</p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Steps;
